import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './maker-board-upload-button.css';
import uploadIcon from './upload.png';

class MakerBoardUploadButton extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            uploading: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick () {
        if (this.state.uploading) return;

        const vm = this.props.vm;
        if (!vm || !vm.runtime) return;

        const makerBoard = vm.runtime.peripheralExtensions.makerBoard;
        if (!makerBoard) {
            // eslint-disable-next-line no-alert
            alert('メイカーボード きほんブロック拡張が読み込まれていません');
            return;
        }

        this.setState({uploading: true});
        try {
            await makerBoard.write();
        } catch (error) {
            console.error(error);
        } finally {
            this.setState({uploading: false});
        }
    }

    render () {
        const {uploading} = this.state;
        const label = uploading ? '書込中…' : '書込';
        const title = uploading ? '書き込み中…' : 'ボードに書き込み';

        return (
            <div
                className={classNames(styles.uploadButton, {
                    [styles.uploading]: uploading,
                    [styles.disabled]: uploading
                })}
                onClick={this.handleClick}
                title={title}
            >
                <div className={styles.iconWrapper}>
                    <img
                        className={classNames(styles.icon, {
                            [styles.iconUploading]: uploading
                        })}
                        src={uploadIcon}
                        alt="書き込み"
                    />
                </div>
                <span className={styles.label}>
                    {label}
                </span>
            </div>
        );
    }
}

MakerBoardUploadButton.propTypes = {
    vm: PropTypes.shape({
        runtime: PropTypes.shape({
            peripheralExtensions: PropTypes.shape({
                makerBoard: PropTypes.shape({
                    write: PropTypes.func
                })
            })
        })
    })
};

export default MakerBoardUploadButton;
